import React from 'react';
import PropTypes from 'prop-types';
import utils from '../../../utils';

const Link = props => {
  const { children, ...p } = props;

  return p.hyperlink ? (
    <a
      href={p.hyperlink}
      rel="noreferrer"
      target={
        p.hyperlink.substr(0, 1) === '#' ||
        p.hyperlink.substr(0, 7) === 'mailto:'
          ? '_self'
          : '_blank'
      }
      onMouseDown={utils.preventDefault}
      {...p}
    >
      {children}
    </a>
  ) : (
    <div {...p}>{children}</div>
  );
};

Link.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

Link.defaultProps = {
  children: null,
};

export default Link;
